import * as userTokenRequests from "../../api/userTokenRequest";
import {START_LOAD, FINISH_LOAD} from "../reducers/event";
import {START_LOAD_CHECK, FINISH_LOAD_CHECK} from "../reducers/check";
import {push} from "./message";
import {EN} from "../../ui/constants";

const startLoading = () => {
    return {type: START_LOAD};
};
const finishLoading = (event) => {
    return {type: FINISH_LOAD, payload: event};
};
const startLoadingCheck = () => {
    return {type: START_LOAD_CHECK};
};
const finishLoadingCheck = (check) => {
    return {type: FINISH_LOAD_CHECK, payload: check};
};

export const getEventById = (id) => {
    return dispatch => {
        dispatch(finishLoading(null));
        dispatch(startLoading());
        userTokenRequests.getEventById(id)
            .then(event => {
                dispatch(finishLoading(event))
            })
            .catch(error => {
                dispatch(finishLoading(null));
                dispatch(push(error.message))
            })
    }
};
export const joinEvent = (id, role) => {
    return dispatch => {
        userTokenRequests.joinEvent(id, role)
            .then(event => {
                dispatch(push(EN.message.join_team));
            })
            .catch(error => {
                dispatch(push(error.message))
            })
    }
};

export const reCreateTeam = (team_id, event_id,isCopy) => {
    return dispatch => {
        userTokenRequests.reCreateTeam(team_id, event_id,isCopy)
            .then(event => {
                dispatch(push(EN.message.re_create_team));
            })
            .catch(error => {
                dispatch(push(error.message))
            })
    }
};

export const getCheck = (event_id) => {
    return dispatch => {
        dispatch(startLoadingCheck());
        userTokenRequests.checkParticipation(event_id)
            .then(check => {
                dispatch(finishLoadingCheck(check))
            })
            .catch(error => {
                dispatch(push(error.message))
            })
    }
};

